(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["okviri-customer-gallery"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-gallery-open]').forEach(function (button) {
    button.addEventListener('click', function () {
      var dialog = document.getElementById(button.getAttribute('data-gallery-open'));
      if (dialog && dialog.showModal) dialog.showModal();
    });
  });
  document.querySelectorAll('.ok-customer-gallery__dialog').forEach(function (dialog) {
    var close = dialog.querySelector('[data-gallery-close]');
    if (close) close.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["okviri-home"] && !Shopify.designMode) return;
  try {
    

  function initHomeGalleries(scope) {
    scope.querySelectorAll('.ok-gallery').forEach(function(gallery) {
      if (gallery.dataset.initialized) return;
      gallery.dataset.initialized = 'true';
      var pages = Array.from(gallery.querySelectorAll('[data-gallery-page]'));
      var previous = gallery.querySelector('[data-gallery-prev]');
      var next = gallery.querySelector('[data-gallery-next]');
      var count = gallery.querySelector('[data-gallery-page-count]');
      var current = 0;
      function show(index) {
        current = Math.max(0, Math.min(pages.length - 1, index));
        pages.forEach(function(page, i) { page.hidden = i !== current; });
        previous.disabled = current === 0;
        next.disabled = current === pages.length - 1;
        count.textContent = (current + 1) + ' / ' + pages.length;
      }
      previous.addEventListener('click', function() { show(current - 1); });
      next.addEventListener('click', function() { show(current + 1); });
      show(0);
    });
  }
  initHomeGalleries(document);

  function initHomeDemos(scope) {
    scope.querySelectorAll('[data-home-demo]').forEach(function(demo) {
      if (demo.dataset.demoInitialized) return;
      demo.dataset.demoInitialized = 'true';
      var slides = Array.from(demo.querySelectorAll('[data-demo-slide]'));
      if (!slides.length) return;
      var current = 0, timer = null, inView = false;
      var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var paused = motion.matches;
      var button = demo.querySelector('[data-demo-pause]');
      function show(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach(function(slide, i) {
          slide.classList.toggle('is-active', i === current);
          slide.setAttribute('aria-hidden', i === current ? 'false' : 'true');
        });
        demo.querySelector('[data-demo-count]').textContent = (current + 1) + ' / ' + slides.length;
      }
      function sync() {
        clearInterval(timer);
        button.textContent = paused ? '▶' : 'Ⅱ';
        button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
        if (!paused && inView && !document.hidden && slides.length > 1) {
          timer = setInterval(function() {
            if (!demo.isConnected) { clearInterval(timer); return; }
            show(current + 1);
          }, 3800);
        }
      }
      button.addEventListener('click', function() { paused = !paused; sync(); });
      demo.querySelector('[data-demo-prev]').addEventListener('click', function() { paused = true; show(current - 1); sync(); });
      demo.querySelector('[data-demo-next]').addEventListener('click', function() { paused = true; show(current + 1); sync(); });
      document.addEventListener('visibilitychange', sync);
      motion.addEventListener('change', function() { paused = motion.matches; sync(); });
      var observer = new IntersectionObserver(function(entries) { inView = entries[0].isIntersecting; sync(); }, {threshold:0.15});
      observer.observe(demo);
      sync();
    });
  }
  initHomeDemos(document);
  document.addEventListener('shopify:section:load', function(event) { initHomeDemos(event.target); initHomeGalleries(event.target); initPopularCategories(event.target); });

  function initPopularCategories(scope) {
    scope.querySelectorAll('[data-popular-categories]').forEach(function(root) {
      if (root.dataset.popularInitialized) return;
      root.dataset.popularInitialized = 'true';
      var cards = Array.from(root.querySelectorAll('[data-category-card]'));
      var remaining = new Set(cards.map(function(card) { return card.dataset.categoryCard; }));
      async function loadPopular() {
        var url = new URL((window.Shopify.routes.root || '/') + 'collections/all', location.origin);
        url.searchParams.set('sort_by', 'best-selling');
        url.searchParams.set('section_id', 'okviri-popular-designs');
        var previewTheme = window.Shopify.theme && window.Shopify.theme.role !== 'main' ? window.Shopify.theme.id : null;
        if (previewTheme) url.searchParams.set('preview_theme_id', String(previewTheme));
        try {
          for (var page = 0; page < 20 && remaining.size; page++) {
            var response = await fetch(url.href, {credentials:'same-origin'});
            if (!response.ok) break;
            var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            var results = doc.querySelector('[data-popular-results]');
            if (!results || results.dataset.sort !== 'best-selling') break;
            for (var item of results.querySelectorAll('[data-popular-key]')) {
              var key = item.dataset.popularKey;
              if (!remaining.has(key)) continue;
              var imageUrl = new URL(item.dataset.image, location.origin);
              if (imageUrl.protocol !== 'https:') continue;
              var loaded = new Image();
              loaded.src = imageUrl.href;
              try { await loaded.decode(); } catch(error) { continue; }
              cards.filter(function(card) { return card.dataset.categoryCard === key; }).forEach(function(card) {
                var image = card.querySelector('img');
                if (!image) return;
                image.removeAttribute('srcset');
                image.removeAttribute('sizes');
                image.src = imageUrl.href;
                image.alt = item.dataset.title;
                card.dataset.popularProduct = item.dataset.productId;
              });
              remaining.delete(key);
            }
            if (!results.dataset.next) break;
            url = new URL(results.dataset.next, location.origin);
            if (url.origin !== location.origin) break;
            url.searchParams.set('sort_by', 'best-selling');
            url.searchParams.set('section_id', 'okviri-popular-designs');
            if (previewTheme) url.searchParams.set('preview_theme_id', String(previewTheme));
          }
          root.dataset.popularStatus = remaining.size === cards.length ? 'fallback' : 'updated';
        } catch(error) { root.dataset.popularStatus = 'fallback'; }
      }
      var observer = new IntersectionObserver(function(entries) {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        loadPopular();
      }, {rootMargin:'300px'});
      observer.observe(root);
    });
  }
  initPopularCategories(document);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
